// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__mr+o0","circle":"main_circle__Tvy5u","labelWrapper":"main_labelWrapper__vCujr"};